// v2 tool catalog — numeric IDs from proto/mecharena/v1/game.proto enum ToolId.
// Source of truth lives in the proto + server/mecharena/tools.py. This is a
// display-only mirror; if the proto enum changes, regen / hand-update here.
// v1 replay data uses mostly the same numbers but a few extras may not map;
// callers fall back to the raw id when toolName() returns `undefined`.

export const TOOL_NAMES: ReadonlyMap<number, string> = new Map([
  [0, "UNSPECIFIED"],
  // Movement
  [1, "WALK"],
  [2, "DASH"],
  [3, "JUMP"],
  [4, "MASC"],
  [5, "JUMP_JETS"],
  // Direct-fire
  [6, "SMALL_LASER"],
  [7, "MEDIUM_LASER"],
  [8, "LARGE_LASER"],
  [9, "PULSE_MEDIUM"],
  [10, "PPC"],
  [11, "MACHINE_GUN"],
  [12, "AC_2"],
  [13, "AC_5"],
  [14, "AC_10"],
  [15, "AC_20"],
  [16, "GAUSS"],
  // Missile
  [17, "SRM_2"],
  [18, "SRM_4"],
  [19, "SRM_6"],
  [20, "LRM_5"],
  [21, "LRM_10"],
  [22, "LRM_15"],
  [23, "LRM_20"],
  // Melee
  [24, "PUNCH"],
  // Defense + utility
  [25, "POP_SMOKE"],
  [26, "AMS"],
  [27, "ECM"],
  [28, "BAP"],
  [29, "TAG"],
  [30, "TARGETING_COMPUTER"],
  [31, "FLUSH_COOLANT"],
  [32, "DOUBLE_HEAT_SINK"],
  [33, "CASE"],
]);

export function toolName(id: number | undefined | null): string | undefined {
  if (id == null) return undefined;
  return TOOL_NAMES.get(id);
}

/** Lookup with a fallback display string for unknown IDs. */
export function toolLabel(id: number | undefined | null): string {
  if (id == null || id === 0) return "—";
  return TOOL_NAMES.get(id) ?? `tool#${id}`;
}

// Facing enum: N=0 then clockwise. (Matches the proto's Facing enum.)
const FACING_LABELS = ["N", "NE", "SE", "S", "SW", "NW"];

export function facingLabel(f: number | undefined | null): string {
  if (f == null) return "?";
  return FACING_LABELS[f] ?? `f#${f}`;
}
